
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.85 2.5a1.5 1.5 0 011.5 1.5v8a1.5 1.5 0 01-1.5 1.5h-9.5a1.5 1.5 0 01-1.5-1.5V4a1.5 1.5 0 011.5-1.5h9.5zm0 1.2h-9.5a.3.3 0 00-.3.3v8a.3.3 0 00.3.3h9.5a.3.3 0 00.3-.3V4a.3.3 0 00-.3-.3zm-1.6 6.05a.55.55 0 010 1.1h-6.4a.55.55 0 010-1.1zM7.3 5.1a.5.5 0 01.5.5v2.5a.5.5 0 01-.5.5H4.8a.5.5 0 01-.5-.5V5.6a.5.5 0 01.5-.5h2.5zm3.95 2.35a.55.55 0 010 1.1h-2a.55.55 0 010-1.1zm0-2.25a.55.55 0 010 1.1h-2a.55.55 0 010-1.1z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    